module.exports = __webpack_public_path__ + "media/summer_tipping_tier_2-6a0eca2d5601b00f72845e502191c2a5.mp3";